import { Component, HostListener, Input } from '@angular/core';
import { TealiumAnalyticsEvent, TealiumAnalyticsService, TealiumConstants } from '@ddt-web/analytics';
import { DialogConfig, DialogService } from '@ddt-web/dialog';

import { ScenarioHeaderConfig } from '../../models/scenarios.interface';

@Component({
	selector: 'sc-mds-group-details',
	templateUrl: './mds-group-details.component.html',
	styleUrls: ['./mds-group-details.component.scss']
})
export class MdsGroupDetailsComponent {
	@Input() public mdsGroup: ScenarioHeaderConfig;

	constructor(private config: DialogConfig, private dialogService: DialogService, private tealiumAnalyticsService: TealiumAnalyticsService) {
		this.mdsGroup = config.data.mdsGroup;
	}

	@HostListener('document:keydown.escape', ['$event']) public onKeydownHandler(event: KeyboardEvent): void {
		this.trackAnalyticEvent('mds group details:keydown escape:close');
		this.dialogService.close();
	}

	/**
	 * Closes the dialog.
	 */
	public closeDialog(): void {
		this.trackAnalyticEvent('mds group details:button:close');
		this.dialogService.close();
	}

	private trackAnalyticEvent(analyticValue: string): void {
		const analyticEvent = new TealiumAnalyticsEvent(TealiumConstants.TOOLS_EVENT.GENERIC, { linkName: analyticValue });
		this.tealiumAnalyticsService.trackEventTealium(analyticEvent);
	}
}
